import { CustomAppLayout } from '../../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
//import { useStore } from '../store';
import { useGlobalState } from '../../../../../context/GlobalStateContext';
const _preserve = React.version;


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { FormField, Link, Modal, SegmentedControl, SpaceBetween, Table } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiArrowRightThinCircleOutline, mdiMinusCircle, mdiPlusCircle, mdiScale, mdiTankerTruck } from '@mdi/js';
import Icon from '@mdi/react';
import Favorites from '../../../../../../components/extras/Favorites';
import TableMovements from '../../../../../../components/tables/tableMovements';
import { fetchWithWatch } from '../../../../../../hooks/fetchWithWatch';
import { ItemsMovement } from '../../../../../../resources/types';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading } from '../../../../../commons/functions';
//reports/ops/tanks
export const OPSFuelTanksFlowsPage = () => {
    const { idUser, data, menu, parameters, version, loading, notifications, displayName, RUT } = useGlobalState();
    useGlobalState();
    const [type, setType] = useState("");
    const [measurements, setMeasurements] = useState<any[]>([]);
    const [movements, setMovements] = useState<ItemsMovement[]>();
    const [measure, setMeasure] = useState<any>();

    useEffect(() => {
        setMovements(undefined)
        handleRefresh();
    }, [type]);


    const handleGetTank = async (measure: any) => {
        try {
            setLoading(true)
            let body = {
                receiptStart: measure.receiptFrom,
                receiptEnd: measure.receiptTo,
                idAccountPlan: 2224148,
                isFuel: 1,
                fuelType: type,
                orderBy: "receipt",
                order: "DESC"
            }
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/movements/list',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify(body),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0) {
                setMovements(data.movements || []);
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally { setLoading(false) }
    }
    const handleRefresh = async () => {
        if (type !== "") {

            setMeasure(undefined)
            setMovements(undefined)
            try {
                setLoading(true)
                const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/private/reports/ops/tanks',
                        'JWT': getCookie("JWT"),
                        //  
                    },
                    body: JSON.stringify({
                        type: type
                    }),
                });

                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }
                const data = await response.json();
                addNotificationStatus(data, setData);
                if (data.code == 0) {
                    const localMeasure = ((data.measurements || []).map((item: any, index: number, array: any) => {
                        const currentCalc = item.liters - item.total;
                        let delta = 0;
                        if (index < array.length - 1) {
                            delta = currentCalc - array[index + 1].liters;
                        } else {
                            // Last row logic (if you want the last row to be 0 or handled differently)
                            delta = 0;
                        }

                        return {
                            ...item,
                            litersFrom: item.liters,
                            litersTo: currentCalc,
                            receipTo: item.receiptTo > 900000 ? "------" : item.receiptTo,
                            delta: delta
                        };
                    }));
                    //console.log(localMeasure)
                    setMeasurements(data.measurements || []);
                }
            } catch (error: any) {
                addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
            } finally { setLoading(false) }
        }
    }
    return (
        <CustomAppLayout
            splitPanelPreferences={{ position: "bottom" }}

            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            splitPanelOpen={!!movements}
            onSplitPanelToggle={(detail) => {
                if (!detail.detail.open) {
                    setMovements(undefined)

                }
            }}
            content={
                <SpaceBetween size="s">
                    <Header variant="h1" actions={<Favorites />}>Flujo de combustible por estanque</Header>

                    <FormField label="Tipo de combustible">
                        <SegmentedControl
                            selectedId={type}
                            onChange={({ detail }) => {
                                setType(detail.selectedId)
                                //window.location.hash = "reports/ops/tanks"
                            }}
                            label="Tipo combustible"
                            options={[
                                { text: "AVGAS", id: "AVGAS" },
                                { text: "JP1", id: "JP1" },
                            ]}
                        />
                    </FormField>
                    {type !== "" && measurements && measurements.length > 0 && (
                        <Table
                            stickyHeader
                            variant='embedded'
                            columnDisplay={[
                                { id: "date", visible: true },
                                {
                                    type: "group", id: "start", visible: true,
                                    children: [
                                        { id: "receiptIni", visible: true },
                                        { id: "liters", visible: true },
                                    ]
                                },
                                { id: "icon", visible: true },
                                {
                                    type: "group", id: "end", visible: true,
                                    children: [
                                        { id: "receiptEnd", visible: true },
                                        { id: "liters2", visible: true },
                                    ]
                                },
                                {
                                    type: "group", id: "consumption", visible: true,
                                    children: [
                                        { id: "totalT", visible: true },
                                        { id: "totalF", visible: true },
                                    ]
                                },
                                { id: "delta", visible: true },

                            ]}
                            groupDefinitions={[
                                { id: "start", header: <div style={{ textAlign: "center" }}>Inicial</div> },
                                { id: "end", header: <div style={{ textAlign: "center" }}>Final</div> },
                                { id: "consumption", header: <div style={{ textAlign: "center" }}>Consumos</div> },
                            ]}
                            columnDefinitions={[
                                {
                                    id: "date",
                                    header: "Fecha",
                                    cell: item => <Link onClick={() => handleGetTank(item)}>{item.dateMeasure}</Link>
                                },
                                {
                                    id: "receiptIni",
                                    header: "Folio",
                                    cell: item => item.receiptFrom
                                },
                                {
                                    id: "liters",
                                    header: "Litros",
                                    cell: item => new Intl.NumberFormat('es-CL').format(item.litersFrom),

                                },
                                {
                                    id: "icon",
                                    header: <div style={{ textAlign: "center" }}><Icon path={mdiArrowRightThinCircleOutline} size={1} /></div>,
                                    cell: item => item.measureType === 'LOAD' ?
                                        <><Icon path={mdiTankerTruck} size={1} /> {new Intl.NumberFormat('es-CL').format(item.load)}</> : <Icon path={mdiScale} size={1} />,
                                },
                                {
                                    id: "receiptEnd",
                                    header: "Folio",
                                    cell: item => item.receiptTo > 900000 ? "------" : item.receiptTo
                                },
                                {
                                    id: "liters2",
                                    header: "Litros",
                                    cell: item => new Intl.NumberFormat('es-CL').format(item.litersTo)
                                },
                                {
                                    id: "totalT",
                                    header: <>Teórico</>,
                                    cell: item => new Intl.NumberFormat('es-CL').format(item.total)
                                },
                                {
                                    id: "totalF",
                                    header: <>Físico</>,
                                    cell: item => new Intl.NumberFormat('es-CL').format(item.litersFrom + item.load - item.litersTo)
                                },
                                {
                                    id: "delta",
                                    header: "Delta",
                                    cell: item => <div style={{ textAlign: "right" }}>{new Intl.NumberFormat('es-CL').format(Math.abs(item.delta))} {(item.delta >= 0 ? <Icon path={mdiPlusCircle} size={0.75} color="blue" /> : <Icon path={mdiMinusCircle} size={0.75} color='red' />)}</div>
                                },
                            ]}
                            items={measurements}
                        />
                    )}

                    <Modal
                        visible={!!movements} onDismiss={() => setMovements(undefined)} closeAriaLabel="Close modal"
                        header={<Header variant="h2">Movimientos entre folios</Header>}
                        size="max"
                    >
                        <TableMovements movements={movements || []} visible={true}
                            dateFilter="NONE" refresh={false} showUser={true} showReceipt={true} showBalance={false}
                            showPayment={false}
                        />
                    </Modal>


                </SpaceBetween>
            }
        />
    )
};
